import { CMTS_BACKEND_ENDPOINTS, CMTS_BACKEND_ENDPOINT_BY_KEY, type CmtsBackendEndpoint } from "./cmtsBackendEndpointRegistry.js";
import { CMTS_SOURCE_ONLY_ENDPOINTS } from "./cmtsSourceOnlyEndpointRegistry.js";

export const CMTS_COMPLETE_BACKEND_ENDPOINTS = [
  ...CMTS_BACKEND_ENDPOINTS,
  ...CMTS_SOURCE_ONLY_ENDPOINTS,
] as const satisfies readonly CmtsBackendEndpoint[];

export const CMTS_COMPLETE_BACKEND_ENDPOINT_BY_KEY: Readonly<Record<string, CmtsBackendEndpoint>> = Object.freeze(
  Object.fromEntries(CMTS_COMPLETE_BACKEND_ENDPOINTS.map((endpoint) => [endpoint.key, endpoint])) as Record<string, CmtsBackendEndpoint>,
);

export const CMTS_COMPLETE_ENDPOINT_COUNTS = Object.freeze({
  compiledEndpointCount: CMTS_BACKEND_ENDPOINTS.length,
  sourceOnlyEndpointCount: CMTS_SOURCE_ONLY_ENDPOINTS.length,
  completeEndpointCount: CMTS_COMPLETE_BACKEND_ENDPOINTS.length,
});

export function getCmtsCompleteEndpointsByController(controllerGroup: string): readonly CmtsBackendEndpoint[] {
  return CMTS_COMPLETE_BACKEND_ENDPOINTS.filter((endpoint) => endpoint.controllerGroup === controllerGroup);
}

export function getCmtsEndpointCoverageSummary() {
  const groups = new Map<string, number>();
  for (const endpoint of CMTS_COMPLETE_BACKEND_ENDPOINTS) groups.set(endpoint.controllerGroup, (groups.get(endpoint.controllerGroup) ?? 0) + 1);
  return {
    ...CMTS_COMPLETE_ENDPOINT_COUNTS,
    controllerGroupCount: groups.size,
    controllerGroups: Array.from(groups.entries()).map(([controllerGroup, count]) => ({ controllerGroup, count })).sort((a, b) => a.controllerGroup.localeCompare(b.controllerGroup)),
  };
}
